import { Stamp } from "lucide-react";
import { StampButton } from "./StampButton";

export const StampPromo = ({ coordonnees, siren }) => (
  <div data-testid="stamp-promo" className="overflow-hidden rounded-lg border border-[hsl(var(--brand))]/25 bg-[hsl(var(--brand-muted))]/40">
    <div className="p-5">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[hsl(var(--brand))] text-white">
          <Stamp className="h-5 w-5" />
        </span>
        <div>
          <h3 className="font-display text-base font-semibold text-[hsl(var(--fg-primary))]">
            Besoin d'un tampon pour cette entreprise&nbsp;?
          </h3>
          <p className="mt-1 text-sm leading-relaxed text-[hsl(var(--fg-secondary))]">
            Créez votre tampon avec ces coordonnées déjà renseignées. Vous arrivez
            directement sur le configurateur printer.fr pour finaliser.
          </p>
        </div>
      </div>

      <StampButton coordonnees={coordonnees} siren={siren} sourcePage="fiche-entreprise" variant="primary" />

      <p className="mt-2 text-center text-xs text-[hsl(var(--fg-muted))]">
        Modèle : tampon 64 × 26 mm (réf. 4914)
      </p>
    </div>
  </div>
);

export default StampPromo;
